// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__wYEPQ","tab":"Tabs_tab__3snZs","tabActive":"Tabs_tabActive__2KdwD"};